import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';

@Component({
  selector: 'disable-popup',
  templateUrl: './disable-popup.component.html',
  styleUrls: ['./disable-popup.component.less', '../../shared/common.less']
})
export class DisablePopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Output() disableEvent = new EventEmitter<boolean>();
  @Input() contactToDisable: string = "";
  
  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  onSuspendInvite() {
    this.disableEvent.emit(false);
  }

  ngOnInit() {}

  /**
   * Valide le format d'une adresse email
   */
  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

}
